import React from 'react';
import PropTypes from 'prop-types';

import HubDestinationModel from 'models/hub-destination';

const propTypes = {
  destination: PropTypes.instanceOf(HubDestinationModel).isRequired,
};

const FeaturedDestination = ({ destination }) => (
  <div className="col-sm-4 col-xs-10 col-xs-offset-1 col-sm-offset-0">
    <a href={destination.linkUrl}>
      <div className="featured-destination">
        <picture>
          <source media="(max-width: 991px)" srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" />
          <img
            className="hidden-lte-sm"
            src={destination.imageUrl}
          />
        </picture>
        <div className="subtext">
          <h3 className="h3-sg text-color-white text-color-dark-slate-lte-sm text-weight-medium bottom">
            {destination.name}
          </h3>
          <div className="text-color-green text-color-hover-green-lighten text-weight-medium featured-link clickable">
            Find Parking &rarr;
          </div>
        </div>
      </div>
    </a>
  </div>
);

FeaturedDestination.propTypes = propTypes;
export default FeaturedDestination;
